import React from "react";
import { Link } from "react-router-dom";
import Footer from "../../Footer";

const D279 = () => {
  return (
    <div className="container" style={{ maxWidth: "80%" }}>
      <h1 className="text-center mt-4">
        WGU Course Buffet: All You Can Read 🍽️📖
      </h1>
      <Link type="button" class="btn btn-secondary" to="/courses">
        <i class="fa-solid fa-circle-arrow-left"></i> Buffet Menu
      </Link>

      <h2 className="text-center">You're viewing D279 - User Interface Design</h2>

      <div className="card my-4">
        <h4 className="text-center mt-4">
          WGU Course Material : <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
          <i class="fa-solid fa-star"></i>
        </h4>
        <h4 className="text-center my-2">Total Time Taken: 5.72 hrs</h4>
        <hr />
        <div className="card-body">
          <p>
            Another easy course. I didn’t do any course material. I just started
            the PA and followed along with the instructions. I did my whole UI
            project on Canva. You can go to Canva, create a blank canvas with a
            monitor screen size, and drop in rectangles and other elements. But
            this was rejected because the instructor didn’t accept Canva, lol.
            So I had to redo everything in PowerPoint.
          </p>
          <p>
            PowerPoint is pretty easy if you've used it before. I remember using
            PowerPoint back in high school, so it was a breeze. It's the same
            concept: you drop in rectangles, text boxes, etc. You can then
            duplicate slides and change certain elements to create a button
            effect. For example, if you click on a box on Slide 1, it takes you
            to Slide 3 with the same things except that box (if you get what I
            mean). That's how I made it interactive.
          </p>
          <p>
            To make something interactive in PowerPoint, just right-click, click
            on Add Link, and you can link it to another slide. Took screenshots
            and uploaded the PowerPoint, and it was accepted.
          </p>
        </div>
      </div>
      <Footer/>
    </div>
  );
};
export default D279;
